export default "<select>\n  <option [value]=\"shaftRoles\" *ngFor=\"let shaftRole of shaftRoles\">\n    {{shaftRole.roleName}}\n  </option>\n</select>\n"